/* src/app/forms/produtos/tiktok/tiktok-category/tiktok-category.component.scss */
.content {
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 20px;
}
.content-tree {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  padding: 15px;
}
.pointerMenu {
  cursor: pointer;
}
.tree-view-container {
  display: flex;
  flex-direction: column;
}
.tree-item {
  display: flex;
  align-items: center;
  padding: 8px;
  border-bottom: 1px solid var(--tem-border);
}
.collapse-icon {
  cursor: pointer;
  margin-right: 8px;
  transition: transform 0.3s ease;
}
.collapse-icon.collapsed {
  transform: rotate(-90deg);
}
.item-content {
  flex: 1;
}
.pointer-menu {
  cursor: pointer;
}
.tree-item.selected {
  background-color: var(--tem-border);
}
actions-buttons {
  display: flex;
  flex-direction: column;
}
/*# sourceMappingURL=tiktok-category.component.css.map */
